export default "__VITE_ASSET__75def9af__"